<template>
    <section>
        <div class="titulo">
            <div class="margem container" style="align-items:flex-end;">
                <h2>Painel de Aprovação de Complementações</h2>
            </div>
        </div>
        <div class="margem container">
            <div class="bloco margem">
                <fieldset class="grid-4" style="margin: 0 0 1rem 0;">
                    <div>
                        <label>Ano / Exercício: </label>
                        <select v-model="anoSelecionado">
                            <option value="" disabled>Selecione</option>
                            <option v-for="item in anos" :key="item" :value="item"> {{ item }} </option>
                        </select>
                    </div>
                </fieldset>
            </div>
            <div class="bloco margem" v-if="categoriaResumo">
                <h3 class="alinha-centro">{{ categoriaResumo.descricao }}</h3>
            </div>
            <div class="bloco margem">
                <div class="cabecalho-bloco-solicitacoes">
                    <div class="filtros-solicitacoes">
                        <select v-model="filtroStatus">
                            <option value="">Todos os status</option>
                            <option value="Pendente">Pendentes</option>
                            <option value="Aprovado">Aprovadas</option>
                            <option value="Reprovado">Reprovadas</option>
                        </select>
                    </div>
                </div>
                <div class="table-container">
                    <table class="tabela">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Categoria</th>
                                <th>Setor</th>
                                <th>Valor Solicitado</th>
                                <th>Justificativa</th>
                                <th>Status</th>
                                <th class="acao-col">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="solicitacoesFiltradas.length === 0">
                                <td colspan="6" style="text-align:center; font-size:0.9rem;"> Nenhuma solicitação
                                    encontrada com os filtros atuais. </td>
                            </tr>
                            <tr v-for="sol in solicitacoesFiltradas" :key="sol.id">
                                <td>{{ formatarData(sol.dataSolicitacao) }}</td>
                                <td>{{ sol.categoria.descricao }}</td>
                                <td>{{ sol.setor }}</td>
                                <td>{{ formatarMoeda(sol.valorSolicitado) }}</td>
                                <td class="justificativa-col"> {{ sol.justificativa }} </td>
                                <td class="status-col">
                                    <span :class="['tag-status', sol.status.toLowerCase()]"> {{ sol.status }} </span>
                                </td>
                                <td class="acao-col">
                                    <button class="acao-secundaria botao-pequeno" @click.stop="abrirModalAnalise(sol)">
                                        Analisar </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- MODAL ANÁLISE / APROVAÇÃO -->
            <div class="modal-mask" v-if="mostrarModalAnalise && solicitacaoEmAnalise" @click.self="fecharModalAnalise">
                <div class="jm margem" style="min-width: 35vw">
                    <div class="alinha-centro">
                        <h3>Analisar solicitação de complementação</h3>
                    </div>
                    <div class="modal-body">
                        <div class="bloco-info">
                            <label><strong>Categoria:</strong> {{ solicitacaoEmAnalise.categoria.descricao }}</label>
                            <label><strong>Data:</strong> {{ formatarData(solicitacaoEmAnalise.dataSolicitacao)
                                }}</label>
                            <label><strong>Valor solicitado:</strong> {{
                                formatarMoeda(solicitacaoEmAnalise.valorSolicitado) }}</label>
                            <label>
                                <strong>Status atual:</strong>
                                <span :class="['tag-status', solicitacaoEmAnalise.status.toLowerCase()]"> {{
                                    solicitacaoEmAnalise.status }} </span>
                            </label>
                            <label><strong>Justificativa do solicitante:</strong></label>
                            <span class="campo-texto"> {{ solicitacaoEmAnalise.justificativa }} </span>
                        </div>
                        <br />
                        <hr />
                        <br />
                        <fieldset class="grid-1">
                            <div>
                                <label>Decisão</label>
                                <select v-model="decisaoGestor">
                                    <option value="" disabled>Selecione</option>
                                    <option value="Aprovado">Aprovar</option>
                                    <option value="Reprovado">Reprovar</option>
                                </select>
                            </div>
                            <div>
                                <label>Observação do gestor</label>
                                <textarea rows="3" v-model="observacaoGestorInput"
                                    placeholder="Justifique a decisão (obrigatório para reprovação)"></textarea>
                            </div>
                        </fieldset>
                        <div class="direita margem submit">
                            <button @click="confirmarDecisao"
                                :disabled="!decisaoGestor || (decisaoGestor === 'Reprovado' && !observacaoGestorInput)">
                                Confirmar decisão </button>
                            <button class="acao-secundaria" @click="fecharModalAnalise">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'AprovacaoComplementacoesView',
    data() {
        const anoAtual = new Date().getFullYear()

        return {
            anos: [anoAtual - 1, anoAtual, anoAtual + 1],
            anoSelecionado: anoAtual,

            dadosOrcamento: [
                {
                    ano: anoAtual,
                    setorId: 1,
                    categorias: [
                        {
                            id: 10,
                            descricao: 'Materiais de Consumo',
                            valorPrevisto: 50000,
                            valorGasto: 27500
                        },
                        {
                            id: 11,
                            descricao: 'Serviços de Terceiros',
                            valorPrevisto: 30000,
                            valorGasto: 9000
                        },
                        {
                            id: 12,
                            descricao: 'Equipamentos',
                            valorPrevisto: 80000,
                            valorGasto: 65000
                        }
                    ]
                },
                {
                    ano: anoAtual - 1,
                    setorId: 1,
                    categorias: [
                        {
                            id: 20,
                            descricao: 'Materiais de Consumo',
                            valorPrevisto: 45000,
                            valorGasto: 44000
                        }
                    ]
                }
            ],

            categoriaSelecionadaId: null,

            solicitacoesComplemento: [
                {
                    id: 1,
                    categoria: { id: 10, descricao: 'Materiais de Consumo' },
                    valorSolicitado: 5000,
                    justificativa:
                        'Reposição de insumos utilizados em manutenções corretivas emergenciais.',
                    status: 'Pendente',
                    observacaoGestor: null,
                    setor: 'Mecanica',
                    dataSolicitacao: new Date(anoAtual, 0, 12).toISOString()
                },
                {
                    id: 2,
                    categoria: { id: 12, descricao: 'Equipamentos' },
                    valorSolicitado: 20000,
                    justificativa:
                        'Aquisição de equipamento para aumentar a disponibilidade de máquinas.',
                    status: 'Aprovado',
                    setor: 'Montagem',
                    observacaoGestor:
                        'Aprovado integralmente. Priorizar compra até o próximo mês.',
                    dataSolicitacao: new Date(anoAtual, 2, 3).toISOString()
                },
                {
                    id: 3,
                    categoria: { id: 11, descricao: 'Serviços de Terceiros' },
                    valorSolicitado: 8000,
                    setor: 'P&D Software',
                    justificativa:
                        'Contratação de empresa especializada em manutenção preventiva.',
                    status: 'Reprovado',
                    observacaoGestor:
                        'Reprovado devido à limitação orçamentária no período.',
                    dataSolicitacao: new Date(anoAtual - 1, 8, 25).toISOString()
                }
            ],

            filtroStatus: '',
            mostrarModalAnalise: false,
            solicitacaoEmAnalise: null,
            decisaoGestor: '',
            observacaoGestorInput: ''
        }
    },

    computed: {
        registroAnoSetor() {
            return (
                this.dadosOrcamento.find(
                    r => r.ano === this.anoSelecionado && r.setorId === this.setorAtual.id
                ) || { categorias: [] }
            )
        },

        categoriasCalculadas() {
            return this.registroAnoSetor.categorias.map(c => {
                const saldo = c.valorPrevisto - c.valorGasto
                const perc = c.valorPrevisto > 0 ? (c.valorGasto / c.valorPrevisto) * 100 : 0

                return {
                    ...c,
                    saldo,
                    percentualUtilizado: Math.min(perc, 999)
                }
            })
        },

        categoriaResumo() {
            if (!this.categoriaSelecionadaId) return null

            const cat = this.categoriasCalculadas.find(
                c => c.id === this.categoriaSelecionadaId
            )

            return cat || null
        },

        solicitacoesOrdenadas() {
            return [...this.solicitacoesComplemento].sort(
                (a, b) => new Date(b.dataSolicitacao) - new Date(a.dataSolicitacao)
            )
        },

        solicitacoesFiltradas() {
            return this.solicitacoesOrdenadas.filter(sol => {
                if (this.filtroStatus && sol.status !== this.filtroStatus) return false
                return true
            })
        },

        resumoSolicitacoes() {
            const total = this.solicitacoesFiltradas.length
            let pendentes = 0
            let aprovadas = 0
            let reprovadas = 0

            this.solicitacoesFiltradas.forEach(sol => {
                const st = sol.status.toLowerCase()
                if (st === 'pendente') pendentes++
                if (st === 'aprovado') aprovadas++
                if (st === 'reprovado') reprovadas++
            })

            return {
                total,
                pendentes,
                aprovadas,
                reprovadas
            }
        }
    },

    methods: {
        selecionarCategoria(cat) {
            this.categoriaSelecionadaId =
                this.categoriaSelecionadaId === cat.id ? null : cat.id
        },

        formatarMoeda(valor) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(valor || 0)
        },

        formatarData(dataIso) {
            const d = new Date(dataIso)
            return d.toLocaleDateString('pt-BR')
        },

        abrirModalAnalise(solicitacao) {
            this.solicitacaoEmAnalise = solicitacao
            this.decisaoGestor = solicitacao.status === 'Pendente' ? '' : solicitacao.status
            this.observacaoGestorInput = solicitacao.observacaoGestor || ''
            this.mostrarModalAnalise = true
        },

        fecharModalAnalise() {
            this.mostrarModalAnalise = false
            this.solicitacaoEmAnalise = null
            this.decisaoGestor = ''
            this.observacaoGestorInput = ''
        },

        confirmarDecisao() {
            if (!this.solicitacaoEmAnalise || !this.decisaoGestor) return

            this.solicitacaoEmAnalise.status = this.decisaoGestor
            this.solicitacaoEmAnalise.observacaoGestor = this.observacaoGestorInput

            this.fecharModalAnalise()
        }
    }
}
</script>
<style scoped>
.table-container {
    overflow-x: auto;
}

.acao-col {
    text-align: center;
}

/* Cards centralizados */
.cards-resumo {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.75rem;
    font-size: 0.9rem;
    text-align: center;
    max-width: 900px;
    margin: 0 auto;
}

.card-resumo {
    border: 1px solid var(--cor-separador);
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    background-color: var(--cor-bg);
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 150px;
}

.card-resumo .label {
    font-size: 0.8rem;
    color: var(--cor-texto-suave);
}

.card-resumo strong {
    font-size: 1rem;
}

.card-resumo.porcentagem strong {
    color: var(--cor-primaria);
}

.progresso-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.progresso-barra {
    flex: 1;
    height: 8px;
    border-radius: 4px;
    background-color: var(--cor-separador);
    overflow: hidden;
}

.progresso-preenchido {
    height: 100%;
    background-color: var(--cor-primaria);
    transition: width 0.3s ease;
}

.progresso-label {
    font-size: 0.8rem;
}

.linha-selecionada {
    background-color: rgba(0, 123, 255, 0.06);
}

.tag-status {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 0.75rem;
}

.tag-status.pendente {
    background-color: var(--cor-alerta);
    color: #000000;
}

.tag-status.aprovado {
    background-color: var(--cor-sucesso);
    color: #ffffff;
}

.tag-status.reprovado {
    background-color: var(--cor-erro);
    color: #ffffff;
}

.justificativa-col {
    max-width: 260px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cabecalho-bloco-solicitacoes {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 1rem;
    margin-bottom: 0.75rem;
    flex-wrap: wrap;
}

.filtros-solicitacoes {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.filtros-solicitacoes select {
    min-width: 180px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-body {
    background-color: var(--cor-bg);
    border-radius: 8px;
    padding: 1rem 1.25rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.campo-texto {
    font-size: 0.85rem;
    line-height: 1.4;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    padding: 0.5rem 0.75rem;
}

.observacao-gestor {
    border-left: 3px solid var(--cor-primaria);
}

.botao-pequeno {
    font-size: 0.8rem;
    padding: 4px 16px;
    height: 28px;
    border-radius: 6px;
    cursor: pointer;
}
</style>
